<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M6.5 5A1.5 1.5 0 005 6.5v51a1.5 1.5 0 003 0v-51A1.5 1.5 0 006.5 5zM57.5 5A1.5 1.5 0 0056 6.5v51a1.5 1.5 0 003 0v-51A1.5 1.5 0 0057.5 5zM47.56 25.94a1.5 1.5 0 00-2.12 2.12l2.44 2.44H16.12l2.44-2.44a1.5 1.5 0 00-2.12-2.12l-5 5a1.49 1.49 0 000 2.12l5 5a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12l-2.44-2.44h31.76l-2.44 2.44a1.49 1.49 0 000 2.12 1.5 1.5 0 002.12 0l5-5a1.49 1.49 0 000-2.12z"/></svg>